import React from "react";
import {
 Box,
 Grid,
 GridItem,
 Text,
 VStack,
 Flex,
 useDisclosure,
 Modal,
 ModalOverlay,
 ModalContent,
 ModalHeader,
 ModalCloseButton,
 ModalBody,
 ModalFooter,
 Divider,
 Button,
 SimpleGrid,
} from "@chakra-ui/react";
import { BiMailSend, BiPhone } from "react-icons/bi";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Footer = () => {
 const { isOpen, onOpen, onClose } = useDisclosure();
 const {
  isOpen: isOpenPrivacy,
  onOpen: onOpenPrivacy,
  onClose: onClosePrivacy,
 } = useDisclosure();

 const navigate = useNavigate();

 return (
  <Box bg="#0f95f9" color="white" py={10} px={4} textAlign={"left"}>
   <Grid
    templateColumns={{
     base: "1fr",
     md: "repeat(4, 1fr)",
     lg: "repeat(5, 1fr)",
    }}
    gap={10}
    maxW="8xl"
    mx="auto"
    alignItems="start"
   >
    {/* Top Courses */}
    <GridItem>
     <VStack align="start" spacing={2}>
      <Text fontSize="1rem" fontWeight="600">
       Top Courses
      </Text>
      {[
       { label: "MBBS in India", path: "/courses/MBBS" },
       { label: "MBBS in Abroad", path: "/abroad-mbbs" },
       { label: "MD/MS in India", path: "/courses/MD" },
       { label: "B.tech in India", path: "/b-tech-list" },
      ].map(({ label, path }) => (
       <Text
        key={label}
        fontSize="1rem"
        _hover={{ color: "#F4903A" }}
        cursor="pointer"
        onClick={() => (window.location.href = path)}
       >
        {label}
       </Text>
      ))}
     </VStack>
    </GridItem>

    {/* Top States */}
    <GridItem>
     <VStack align="start" spacing={2}>
      <Text fontSize="1rem" fontWeight="600">
       Top States
      </Text>
      <SimpleGrid columns={2} spacing={2}>
       {[
        "Bihar",
        "Delhi",
        "Gujarat",
        "Karnataka",
        "Kerala",
        "Maharashtra",
        "Rajasthan",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
       ]
        .sort()
        .map((state) => (
         <Text
          key={state}
          whiteSpace="nowrap"
          fontSize="1rem"
          _hover={{ color: "#F4903A" }}
          cursor="pointer"
          onClick={() => navigate(`/state/${state}`)}
         >
          {state}
         </Text>
        ))}
      </SimpleGrid>
     </VStack>
    </GridItem>

    {/* Legal */}
    <GridItem>
     <VStack align="start" spacing={2}>
      <Text fontSize="1rem" fontWeight="600">
       Legal
      </Text>
      <Text
       onClick={() => (window.location.href = "/about")}
       _hover={{ color: "#F4903A" }}
       cursor="pointer"
      >
       About Us
      </Text>
      <Text
       onClick={() => (window.location.href = "/blogs")}
       _hover={{ color: "#F4903A" }}
       cursor="pointer"
      >
       Blog
      </Text>
      <Text
       onClick={() => (window.location.href = "/contact")}
       _hover={{ color: "#F4903A" }}
       cursor="pointer"
      >
       Contact Us
      </Text>
      <Text
       onClick={() => (window.location.href = "/termsandconditions")}
       _hover={{ color: "#F4903A" }}
       cursor="pointer"
      >
       T&C
      </Text>
      <Text
       onClick={() => (window.location.href = "/privacypolicy")}
       _hover={{ color: "#F4903A" }}
       cursor="pointer"
      >
       Privacy Policy
      </Text>
      {/* <Text onClick={onOpen} _hover={{ color: "#F4903A" }} cursor="pointer">
       T&C
      </Text> */}
      {/* <Text
       onClick={onOpenPrivacy}
       _hover={{ color: "#F4903A" }}
       cursor="pointer"
      >
       Privacy Policy
      </Text> */}
     </VStack>
    </GridItem>

    {/* Contact */}
    <GridItem colSpan={{ base: 1, md: 1 }}>
     <VStack align="start" spacing={4}>
      <Flex align="start">
       <Box pt={1}>
        <FaMapMarkerAlt size={20} color="orange" />
       </Box>
       <Text ml={2} fontWeight="500" textAlign="left" whiteSpace="normal">
        812, 8th Floor, Tower B, Assotech Business Cresterra, Sec-135,
        Noida-201301
       </Text>
      </Flex>
      <Flex align="start">
       <Box pt={1}>
        <BiPhone size={22} color="orange" />
       </Box>
       <Text ml={2} fontWeight="500" textAlign="left" whiteSpace="normal">
        Phone: +91 9988661558
       </Text>
      </Flex>
      <Flex align="start">
       <Box pt={1}>
        <BiMailSend size={22} color="orange" />
       </Box>
       <Text ml={2} fontWeight="500" textAlign="left" whiteSpace="normal">
        Gmail: Support@admissionpossibility.com
       </Text>
      </Flex>
     </VStack>
    </GridItem>
   </Grid>

   <Text mt={10} color="orange" textAlign="center" fontSize="sm">
    Developed By ARV Multimedia Pvt. Ltd.
   </Text>
   <Modal
    isOpen={isOpenPrivacy}
    onClose={onClosePrivacy}
    isCentered
    scrollBehavior="inside"
    size={"xl"}
   >
    <ModalOverlay />
    <ModalContent maxW={"xl"} borderRadius="lg" boxShadow="2xl">
     <ModalHeader
      fontWeight="bold"
      fontSize={{ base: "lg", md: "2xl" }}
      textAlign="center"
      color="blue.700"
     >
      🔐 Privacy Policy
     </ModalHeader>
     <ModalCloseButton />
     <ModalBody px={6} py={4} bg="gray.50">
      <VStack align="start" spacing={4} color="gray.700">
       <Text fontSize="md" lineHeight="1.7">
        📥 <b>1. Information Collection:</b> We may collect personal information
        from users when they interact with our website, submit forms, or engage
        with our consultancy services. This information may include, but is not
        limited to, names, contact details, academic records, and other relevant
        details necessary for the admission process.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        📊 <b>2. Use of Information:</b> Admission Possibility may use the
        collected information for the following purposes:
        <ul style={{ paddingLeft: "1.2rem", marginTop: "0.5rem" }}>
         <li>📌 Facilitating the admission process to medical colleges.</li>
         <li>📌 Providing personalized consultancy services.</li>
         <li>📌 Sending relevant updates and notifications.</li>
         <li>📌 Improving our services based on user feedback.</li>
        </ul>
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        🔄 <b>3. Information Sharing:</b> We do not sell, trade, or rent users'
        personal information. However, we may share information with trusted
        third parties who assist us in operating our website or conducting our
        business, provided they agree to keep the information confidential.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        🛡️ <b>4. Security Measures:</b> Admission Possibility employs
        industry-standard security measures to protect against unauthorized
        access, alteration, disclosure, or destruction of personal information.
        However, no method of transmission over the internet or electronic
        storage is entirely secure, and we cannot guarantee absolute security.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        ✏️ <b>5. User Control:</b> Users have the right to access, modify, or
        delete their personal information. They can contact us at{" "}
        <b>contact@admissionpossibility.com</b> to make such requests.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        🍪 <b>6. Cookies and Tracking:</b> Admission Possibility may use cookies
        and similar tracking technologies to enhance user experience. Users can
        adjust their browser settings to refuse cookies or receive notifications
        when cookies are being sent. Please note that disabling cookies may
        affect the functionality of some parts of our website.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        👶 <b>7. Children's Privacy:</b> Admission Possibility does not
        knowingly collect personal information from children under the age of
        13. If you believe that we have inadvertently collected such
        information, please contact us, and we will take steps to delete it.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        📅 <b>8. Changes to Privacy Policy:</b> Admission Possibility reserves
        the right to update this Privacy Policy. Users are encouraged to review
        this page periodically for changes. By continuing to use our services
        after any modifications, users acknowledge and agree to the updated
        terms.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        📧 <b>9. Contact Information:</b> For any questions or concerns
        regarding this Privacy Policy, users can contact Admission Possibility
        at <b>contact@admissionpossibility.com</b>.
       </Text>
       <Text fontSize="md" fontWeight="semibold" color="gray.800">
        📌 This Privacy Policy is effective as of January 2024 and was last
        updated on January 2024.
       </Text>
      </VStack>
     </ModalBody>
     <ModalFooter>
      <Button onClick={onClosePrivacy} colorScheme="blue" variant="solid">
       Close
      </Button>
     </ModalFooter>
    </ModalContent>
   </Modal>
   {/* <Modal
    onClose={onClosePrivacy}
    style={{ width: "50vw" }}
    isOpen={isOpenPrivacy}
    isCentered
   >
    <ModalOverlay />
    <ModalContent>
     <ModalHeader>Privacy Policy</ModalHeader>
     <ModalCloseButton />
     <ModalBody>
      <Box
       padding="4"
       margin="6"
       backgroundColor="gray.50"
       borderRadius="md"
       boxShadow="sm"
      >
       <Divider marginTop="4" marginBottom="4" borderColor="gray.200" />

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        1. <b>Information Collection:</b> We may collect personal information
        from users when they interact with our website, submit forms, or engage
        with our consultancy services. This information may include, but is not
        limited to, names, contact details, academic records, and other relevant
        details necessary for the admission process.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        2. <b>Use of Information:</b> Admission Possibility may use the
        collected information for the following purposes:
        <ul>
         <li>Facilitating the admission process to medical colleges.</li>
         <li>Providing personalized consultancy services.</li>
         <li>Sending relevant updates and notifications.</li>
         <li>Improving our services based on user feedback.</li>
        </ul>
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        3. <b>Information Sharing:</b> We do not sell, trade, or rent users'
        personal information. However, we may share information with trusted
        third parties who assist us in operating our website or conducting our
        business, provided they agree to keep the information confidential.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        4. <b>Security Measures:</b> Admission Possibility employs
        industry-standard security measures to protect against unauthorized
        access, alteration, disclosure, or destruction of personal information.
        However, no method of transmission over the internet or electronic
        storage is entirely secure, and we cannot guarantee absolute security.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        5. <b>User Control:</b> Users have the right to access, modify, or
        delete their personal information. They can contact us at
        [contact@admissionpossibility.com] to make such requests.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        6. <b>Cookies and Tracking:</b> Admission Possibility may use cookies
        and similar tracking technologies to enhance user experience. Users can
        adjust their browser settings to refuse cookies or receive notifications
        when cookies are being sent. Please note that disabling cookies may
        affect the functionality of some parts of our website.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        7. <b>Children's Privacy:</b> Admission Possibility does not knowingly
        collect personal information from children under the age of 13. If you
        believe that we have inadvertently collected such information, please
        contact us, and we will take steps to delete it.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        8. <b>Changes to Privacy Policy:</b> Admission Possibility reserves the
        right to update this Privacy Policy. Users are encouraged to review this
        page periodically for changes. By continuing to use our services after
        any modifications, users acknowledge and agree to the updated terms.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        9. <b>Contact Information:</b> For any questions or concerns regarding
        this Privacy Policy, users can contact Admission Possibility at
        [contact@admissionpossibility.com].
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        This Privacy Policy is effective as of January 2024 and was last updated
        on January 2024.
       </Text>
      </Box>
     </ModalBody>
     <ModalFooter>
      <Button onClick={onClosePrivacy}>Close</Button>
     </ModalFooter>
    </ModalContent>
   </Modal> */}
   <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior="inside">
    <ModalOverlay />
    <ModalContent maxW={"xl"} borderRadius="lg" boxShadow="2xl">
     <ModalHeader
      fontWeight="bold"
      fontSize={{ base: "lg", md: "2xl" }}
      textAlign="center"
      color="blue.700"
     >
      📜 Terms & Conditions
     </ModalHeader>
     <ModalCloseButton />
     <ModalBody px={6} py={4} bg="gray.50">
      <VStack align="start" spacing={4} color="gray.700">
       <Text fontSize="md" lineHeight="1.7">
        📖 <b>1. Acceptance of Terms:</b> By accessing or using the services
        provided by Admission Possibility, you agree to be bound by these terms
        and conditions. If you do not agree with any part of these terms, you
        may not use our services.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        💼 <b>2. Services:</b> Admission Possibility provides consultancy
        services to assist individuals in the admission process to medical
        colleges. Our services include but are not limited to providing
        information on medical colleges, advising on application processes, and
        offering guidance on admission requirements.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        🧑‍🎓 <b>3. Eligibility:</b> Our services are available to individuals who
        meet the eligibility criteria for admission to medical colleges.
        Admission Possibility reserves the right to refuse services to anyone
        for any reason at any time.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        💳 <b>4. Fees and Payments:</b> Details regarding consultancy fees and
        payment terms are outlined separately in the fee agreement provided to
        the user. Users are responsible for the timely payment of all applicable
        fees.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        🔍 <b>5. Information Accuracy:</b> While Admission Possibility strives
        to provide accurate and up-to-date information, we do not guarantee the
        accuracy, completeness, or reliability of any information on our
        website. Users are encouraged to verify all details independently.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        🔐 <b>6. Confidentiality:</b> Admission Possibility will handle user
        information in accordance with our privacy policy. Users are responsible
        for the accuracy and security of the information they provide.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        ⚠️ <b>7. Limitation of Liability:</b> Admission Possibility shall not be
        liable for any direct, indirect, incidental, consequential, or punitive
        damages arising out of the use or inability to use our services.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        🚫 <b>8. Termination:</b> Admission Possibility reserves the right to
        terminate services for any user who violates these terms and conditions
        or engages in any conduct deemed inappropriate.
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        ⚖️ <b>9. Governing Law:</b> These terms and conditions are governed by
        and construed in accordance with the laws of [Your Jurisdiction]. Any
        disputes arising out of or in connection with these terms will be
        subject to the exclusive jurisdiction of the courts in [Your
        Jurisdiction].
       </Text>
       <Text fontSize="md" lineHeight="1.7">
        🔄 <b>10. Changes to Terms:</b> Admission Possibility reserves the right
        to update or modify these terms and conditions at any time without prior
        notice. Users are encouraged to review the terms periodically for
        changes.
       </Text>
       <Text fontSize="md" fontWeight="semibold" color="gray.800">
        ✅ By using Admission Possibility's services, you acknowledge that you
        have read, understood, and agree to these terms and conditions.
       </Text>
      </VStack>
     </ModalBody>
     <ModalFooter>
      <Button onClick={onClose} colorScheme="blue" variant="solid">
       Close
      </Button>
     </ModalFooter>
    </ModalContent>
   </Modal>
   {/* <Modal
    onClose={onClose}
    style={{ width: "50vw" }}
    isOpen={isOpen}
    isCentered
   >
    <ModalOverlay />
    <ModalContent>
     <ModalHeader>Admission Services Terms and Conditions</ModalHeader>

     <ModalCloseButton />
     <ModalBody>
      <Box
       padding="4"
       margin="6"
       backgroundColor="gray.50"
       borderRadius="md"
       boxShadow="sm"
      >
       <Divider marginTop="4" marginBottom="4" borderColor="gray.200" />
       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        1. <b>Acceptance of Terms:</b> By accessing or using the services
        provided by Admission Possibility, you agree to be bound by these terms
        and conditions. If you do not agree with any part of these terms, you
        may not use our services.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        2. <b>Services:</b> Admission Possibility provides consultancy services
        to assist individuals in the admission process to medical colleges. Our
        services include but are not limited to providing information on medical
        colleges, advising on application processes, and offering guidance on
        admission requirements.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        3. <b>Eligibility:</b> Our services are available to individuals who
        meet the eligibility criteria for admission to medical colleges.
        Admission Possibility reserves the right to refuse services to anyone
        for any reason at any time.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        4. <b>Fees and Payments:</b> Details regarding consultancy fees and
        payment terms are outlined separately in the fee agreement provided to
        the user. Users are responsible for the timely payment of all applicable
        fees.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        5. <b>Information Accuracy:</b> While Admission Possibility strives to
        provide accurate and up-to-date information, we do not guarantee the
        accuracy, completeness, or reliability of any information on our
        website. Users are encouraged to verify all details independently.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        6. <b>Confidentiality:</b> Admission Possibility will handle user
        information in accordance with our privacy policy. Users are responsible
        for the accuracy and security of the information they provide.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        7. <b>Limitation of Liability:</b> Admission Possibility shall not be
        liable for any direct, indirect, incidental, consequential, or punitive
        damages arising out of the use or inability to use our services.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        8. <b>Termination:</b> Admission Possibility reserves the right to
        terminate services for any user who violates these terms and conditions
        or engages in any conduct deemed inappropriate.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        9. <b>Governing Law:</b> These terms and conditions are governed by and
        construed in accordance with the laws of [Your Jurisdiction]. Any
        disputes arising out of or in connection with these terms will be
        subject to the exclusive jurisdiction of the courts in [Your
        Jurisdiction].
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        10. <b>Changes to Terms:</b> Admission Possibility reserves the right to
        update or modify these terms and conditions at any time without prior
        notice. Users are encouraged to review the terms periodically for
        changes.
       </Text>

       <Text fontSize="md" lineHeight="1.5" color="gray.600" marginBottom="4">
        By using Admission Possibility's services, you acknowledge that you have
        read, understood, and agree to these terms and conditions.
       </Text>
      </Box>
     </ModalBody>
     <ModalFooter>
      <Button onClick={onClose}>Close</Button>
     </ModalFooter>
    </ModalContent>
   </Modal> */}
  </Box>
 );
};

export default Footer;
